module.exports = __webpack_public_path__ + "img/cn.daa4b5a7.svg";